module.exports = __webpack_public_path__ + "static/media/dodgem(3).794824e1.PNG";